import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

export interface RedemptionHeaderProps {
  onClose: () => void;
  numberOfSteps?: number;
  currentStep?: number;
}

export const RedemptionHeader: React.FC<RedemptionHeaderProps> = ({
  onClose,
  currentStep = 1,
  numberOfSteps = 1,
}) => {
  const hasSteps = numberOfSteps > 1;

  return (
    <HStack justifyContent="space-between">
      <HStack space={Spacing['inline.nano']} alignItems="center">
        {!!hasSteps && (
          <UI.IconButton
            onPress={onClose}
            icon="ArrowLeft"
            iconSize="xs"
            testId="back"
            iconColor={Color['neutral.black']}
            p={0}
          />
        )}
        <UI.Text variant="semibold" color="neutral.black">
          Solicitação de resgate
        </UI.Text>
      </HStack>
      {hasSteps ? (
        <UI.Steps
          testId="redemption-solicitation-steps"
          currentStep={currentStep}
          totalSteps={numberOfSteps}
        />
      ) : (
        <UI.IconButton
          testId="icon"
          icon="CloseModal"
          iconSize="xs"
          p={0}
          variant="rounded"
          borderWidth={0.05}
          backgroundColor="transparent"
          iconColor={Color['brand.primary.principal']}
          borderColor={Color['brand.primary.principal']}
          onPress={onClose}
        />
      )}
    </HStack>
  );
};
